export default {
  isValidLogin() {
    return true
  },
  toLogin(nextPath) {
  },
  permissionCheck(permission, role) {
    return true
  },
  sendVisitRecord(to) {
  }
}